var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{staticClass:"px-4",attrs:{"column":"","fill-height":"","id":"mlo-0800","justify-center":"","align-center":""}},[_c('v-spacer'),_c('img',{staticClass:"mb-5",style:({
          width: _vm.primary.width,
          height: _vm.primary.height,
        }),attrs:{"src":_vm.primary.icon,"alt":""}}),_c('v-progress-circular',{staticClass:"absolute-center",attrs:{"color":"primary","indeterminate":""}}),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }